define.alias("shared/components/shared/wizard", "media/components/shared/wizard");